import { expandElement } from '../utils/helper.ts';
import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';

class BFGProfile extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.selector && this.init();
	}

	init() {
		const showAllServicesBtn = this.selector.querySelector( '.js-show-all-services-btn' ) as HTMLElement;
		if ( showAllServicesBtn ) {
			const wrapperEle = showAllServicesBtn?.closest( '#bfg-profile-brand' ) as HTMLElement;
			showAllServicesBtn.addEventListener( 'click', () =>
				expandElement( showAllServicesBtn, wrapperEle, 'Show more', 'Show less' ),
			);
		}

		const expandOverseasCountries = this.selector.querySelector( '.js-expand-overseas-countries' ) as HTMLElement;
		if ( expandOverseasCountries ) {
			const wrapperEle = expandOverseasCountries?.closest( '#bfg-profile-location' ) as HTMLElement;
			const numberShowMore = expandOverseasCountries.dataset.numberShowMore;
			const showMoreText = `+ ${numberShowMore} more`;
			expandOverseasCountries.addEventListener( 'click', () =>
				expandElement( expandOverseasCountries, wrapperEle, showMoreText, 'Show less' ),
			);
		}

		const contactInfoBtn = this.selector.querySelector( '.js-bfg-profile-contact-info' ) as HTMLElement;
		const popup = this.selector.querySelector( '.js-bfg-brand-contact-info-popup' ) as HTMLElement;
		const closePopupBtn = popup.querySelector( '.js-close-popup' ) as HTMLElement;
		if ( contactInfoBtn ) {
			contactInfoBtn.addEventListener( 'click', () => {
				popup && popup.classList.toggle( 'open' );
				const body = document.querySelector( 'body' ) as HTMLElement;
				if ( popup.classList.contains( 'open' ) ) {
					body.classList.add( 'overflow-hidden' );
				} else {
					body.classList.remove( 'overflow-hidden' );
				}
			} );
		}
		if ( closePopupBtn ) {
			closePopupBtn.addEventListener( 'click', () => {
				popup && popup.classList.remove( 'open' );
				const body = document.querySelector( 'body' ) as HTMLElement;
				body.classList.remove( 'overflow-hidden' );
			} );
		}
	}
}

export default BFGProfile;
